document.addEventListener("DOMContentLoaded", function (event) {
  const isHidden = function (el) {
    return el.offsetParent === null;
  };

  const disableDuplicatedInput = function () {
    const inputs = document.querySelectorAll('input[name="updates[]"]');
    inputs.forEach(function (input) {
      if (isHidden(input)) {
        input.disabled = true;
      }
    });
  };
  disableDuplicatedInput();

  // [name="updates[]"]がなくなることがあるので監視する
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === "childList") {
        disableDuplicatedInput();
      }
    });
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});
